/**
 * Canonical route for a historical /v2 URL.
 *
 * The V2 shell is retired, but old bookmarks, emails and external integrations
 * must continue to work. Most routes map by removing the prefix; the small
 * alias table covers pages whose legacy name differs.
 */
export function legacyPathForV2Path(pathname) {
  const stripped = String(pathname || '').replace(/^\/v2(?=\/|$)/, '') || '/home';
  const aliases = {
    '/ops-home': '/dashboard',
    '/safety': '/safety-guide',
    '/safety-briefing': '/tem',
    '/fuel-entry': '/unified-fuel-entry',
    '/logbook': '/flight-logs',
  };
  return aliases[stripped] || stripped;
}
